module.exports = __webpack_public_path__ + "static/media/model-bottom.d36d8719.png";